
import BundleModalDetails from '../bundle-modal-details/index.vue'
import BundleProductTitle from './bundle-product-title.vue'
import BundleProductPrice from './bundle-product-price.vue'
import BundleProductColors from './bundle-product-colors.vue'
import BundleProductSizes from './bundle-product-sizes.vue'
import BundleFittingGuide from './bundle-fitting-guide.vue'

export default {
  components: {
    BundleProductTitle,
    BundleProductPrice,
    BundleProductColors,
    BundleProductSizes,
    BundleFittingGuide,
    BundleModalDetails,
  },
  inject: ['wording'],
  provide() {
    return {
      productGroup: this.productGroup,
      wording: this.wording,
    }
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
    productGroup: {
      type: Array,
      required: true,
    },
    defaultColor: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      wording: this.wording,
      selectedColor: this.defaultColor,
      selectedSize: null,
      isOpenMoreDetails: false,
    }
  },
  computed: {
    selectedVariant() {
      return this.productGroup.filter(
        (p) => p.internal_color_code === this.selectedColor
      )[0]
    },
  },
  watch: {
    selectedSize(newVal, oldVal) {
      let size
      if (newVal) {
        size = JSON.parse(newVal)
        this.$emit('variantAdd', {
          product: this.selectedVariant,
          size,
        })
      } else {
        size = JSON.parse(oldVal)
        this.$emit('variantRemove', {
          product: this.selectedVariant,
          size,
        })
      }
    },
  },
  methods: {
    openMoreDetails() {
      this.isOpenMoreDetails = true
    },
    sizeSelect(size) {
      this.selectedSize = size
    },
    colorSelect(color) {
      this.selectedColor = color
    },
  },
}
